/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import RegistrationView from "../views/RegistrationView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import ConfirmationView from "../views/ConfirmationView.vue";
import ClotureView from "@/views/ClotureView.vue";

import { countRegistration } from "@/plugins/server";
import loader from "@/services/loader";

Vue.use(VueRouter);

const nbGuestMax = 11; // Maximum number of guests allowed
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function isMaxGuest(to, from, next) {
    var nbGuest = 0;
    countRegistration()
        .then(async (result) => {
            nbGuest = result.data;
            console.log("nbGuest", nbGuest);
            loader.hideLoader();
            if (nbGuest >= nbGuestMax) {
                next({
                    name: "cloture",
                });
            } else {
                next();
            }
        })
        .catch((error) => {
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.log(code, message, details);
            this.$data.hasError = true;
        });
}

const routes = [
    {
        path: "/",
        name: "home",
        component: RegistrationView,
    },
    {
        path: "/inscription-cloturee",
        name: "cloture",
        component: ClotureView,
    },
    {
        path: "/confirmation",
        name: "done",
        component: ConfirmationView,
    },
    {
        path: "/404-not-found",
        name: "404",
        component: NotFoundView,
    },
    {
        path: "*",
        redirect: { name: "404" },
    },
];

const router = new VueRouter({
    mode: "history",
    base: __dirname,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(
                    to.hash && to.hash != "#"
                        ? {
                            selector: to.hash,
                            offset: { x: 0, y: 0 },
                            behavior: "smooth",
                        }
                        : { x: 0, y: 0 }
                );
            }, 250);
        });
    },
});

export default router;
